<template>
    <div class="animated fadeIn">
        <DynamicList
                ref="dynamicCardList"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                :onRetrieve="onRetrieve"
                root="/report/event-bookings"
                :searchArgs="searchArgs">

            <slot slot="afterSearchForm">
                <b-button @click="$refs.modalExport.open = true" variant="light" class="mb-3">
                    {{Core.Definition.getDefinition("Exporter sous format ...")}}
                </b-button>
                <ModalExport
                        ref="modalExport"
                        root="/report/event-bookings"
                        :formStructure="{
                                rows: [
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'exportFormat'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                     {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'exportTitle'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'id'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'status'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'eventId'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'eventDateStart'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'eventDateEnd'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'userFirstname'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'userLastname'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'userPhone'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'userEmail'
                                                    }
                                                ]
                                            },
                                            {

                                            }
                                        ]
                                    }
                                ],
                                fields: [
                                    {
                                        id: 'exportFormat',
                                        type: 'select',
                                        options: Core.Export.formatOptions(),
                                        label: Core.Definition.getDefinition('Format'),
                                        value: null,
                                        onSelect: function() {}
                                    },
                                    {
                                        id: 'exportTitle',
                                        type: 'text',
                                        label: Core.Definition.getDefinition('Titre'),
                                        value: '',
                                        required: true
                                    },
                                    {
                                        id: 'id',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('ID'),
                                        value: true,
                                        export: 'id',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'status',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('État'),
                                        value: true,
                                         export: 'status',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'eventId',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Événement'),
                                        value: true,
                                         export: 'eventDateTitle',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'eventDateStart',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Début'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'eventDateStart',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'eventDateEnd',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Fin'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'eventDateEnd',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'userFirstname',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Prénom'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'userFirstname',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'userLastname',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Nom de famille'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'userLastname',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'userPhone',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Téléphone'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'userPhone',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'userEmail',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Courriel'),
                                        value: true,
                                        labelCols: 6,
                                        export: 'userEmail',
                                        onChange: function() {}
                                    }
                                ]}"

                @onSubmit="onExport">
                </ModalExport>
            </slot>
        </DynamicList>

    </div>
</template>

<script>
    import DynamicList from '../../../../components/DynamicList'
    import CardChartBar from '../../../../components/CardChartBar'
    import ModalExport from '../../../../components/ModalExport'
    export default {
        name: 'ReportEventBooking',
        components: {
            DynamicList,
            CardChartBar,
            ModalExport
        },
        props: {
            searchArgs: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataSearchArgs: [],
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('ID'),
                        key: 'id',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Réservation'),
                        key: 'bookDate',
                        type: 'date',
                        format: 'DD MMM YYYY HH:mm',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Annulation'),
                        key: 'cancelDate',
                        type: 'date',
                        format: 'DD MMM YYYY HH:mm',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('État'),
                        key: 'status',
                        type: 'select',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Événement'),
                        key: 'eventId',
                        type: 'text',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Début'),
                        key: 'eventDateStart',
                        type: 'date',
                        format: 'DD MMM YYYY HH:mm',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Fin'),
                        key: 'eventDateEnd',
                        type: 'date',
                        format: 'DD MMM YYYY HH:mm',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Prénom'),
                        key: 'userFirstname',
                        type: 'text',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Nom de famille'),
                        key: 'userLastname',
                        type: 'text',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Courriel'),
                        key: 'userEmail',
                        type: 'text',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Téléphone'),
                        key: 'userPhone',
                        type: 'text',
                        sortable: true
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'eventId'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'eventDateStart'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'eventDateEnd'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'status'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'userFirstname'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'userLastname'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'userEmail'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'userPhone'
                                        }
                                    ]
                                }
                            ]
                        },
                    ],
                    fields: [
                        {
                            id: 'eventId',
                            type: 'select',
                            label: Core.Definition.getDefinition('Événement'),
                        },
                        {
                            id: 'status',
                            type: 'select',
                            label: Core.Definition.getDefinition('État'),
                            onSelect: function() {}
                        },
                        {
                            id: 'eventDateStart',
                            type: 'date',
                            label: Core.Definition.getDefinition('Début'),
                        },
                        {
                            id: 'eventDateEnd',
                            type: 'date',
                            label: Core.Definition.getDefinition('Fin'),
                        },
                        {
                            id: 'userFirstname',
                            type: 'text',
                            label: Core.Definition.getDefinition('Prénom'),
                            value: ''
                        },
                        {
                            id: 'userLastname',
                            type: 'text',
                            label: Core.Definition.getDefinition('Nom de famille'),
                            value: ''
                        },
                        {
                            id: 'userPhone',
                            type: 'text',
                            label: Core.Definition.getDefinition('Téléphone'),
                            value: ''
                        },
                        {
                            id: 'userEmail',
                            type: 'text',
                            label: Core.Definition.getDefinition('Courriel'),
                            value: ''
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                }
            }
        },
        methods: {
            onExport() {
                let searchArgs = this.$refs.dynamicCardList.$refs.request.dataArgs
                for(let searchArg in searchArgs) {
                    searchArg = searchArgs[searchArg]
                    this.$refs.modalExport.$refs.request.addArg(searchArg.key, searchArg.value, searchArg.type)
                }
            },
            onRetrieve(data) {
            },
            clickEdit(value, cell, row) {
                this.$router.push(Core.Text.format(Core.Definition.getDefinition('/evenement/reservations/{0}/{1}'), row.eventDateStart, row.eventDateId))
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
